export const Manifesto = () => {
    return (
        <section
            data-testid="manifesto-section"
            className="relative bg-white py-32 md:py-48 overflow-hidden"
        >
            {/* Big quote marks */}
            <div className="absolute top-6 left-6 md:top-16 md:left-16 font-display font-extrabold text-[180px] md:text-[280px] leading-none text-[#F0493E]/10 select-none pointer-events-none">
                &ldquo;
            </div>
            <div className="absolute bottom-6 right-6 md:bottom-16 md:right-16 font-display font-extrabold text-[180px] md:text-[280px] leading-none text-[#F0493E]/10 select-none pointer-events-none rotate-180">
                &ldquo;
            </div>

            <div className="relative max-w-5xl mx-auto px-6 md:px-12 text-center reveal">
                <div className="inline-flex items-center gap-3 mb-10">
                    <span className="h-px w-10 bg-[#F0493E]" />
                    <span className="text-[11px] md:text-xs font-bold uppercase tracking-[0.32em] text-[#F0493E]">
                        Our Belief
                    </span>
                    <span className="h-px w-10 bg-[#F0493E]" />
                </div>

                <p className="font-display font-extrabold text-3xl md:text-5xl lg:text-6xl leading-[1.05] tracking-tighter text-[#0A1428] text-balance">
                    Naloxone is over-the-counter.
                    <br />
                    <span className="text-[#F0493E]">
                        Distribution is the gap —
                    </span>
                    <br />
                    and distance is solvable.
                </p>

                <div className="mt-12 flex items-center justify-center gap-3">
                    <div className="h-px w-12 bg-slate-300" />
                    <span className="font-display font-bold text-[#0A1428] text-sm uppercase tracking-[0.25em]">
                        Kairos ORD LLC
                    </span>
                    <div className="h-px w-12 bg-slate-300" />
                </div>
            </div>
        </section>
    );
};
